import { IsUrl } from 'class-validator';

import { FacebookContextModel } from './facebookContext.model';

export class FacebookPageViewModel extends FacebookContextModel {
  @IsUrl()
  public sourceUrl: string;
}
